import { useEffect, useState } from "react";
import axiosWithAuth from "../helpers/AxiosHelper";

// Env-switched features of this deployment (backend GET /features, driven by
// PLATFORM_REPORT_ENABLED / COMPARTMENT_REPORT_ENABLED), fetched once and
// shared by every caller. null until loaded - callers treat that as "off" so
// a disabled page never flashes into the nav.
let features_cache = null;
let features_request = null;

export const useFeatures = () => {
    const [features, setFeatures] = useState(features_cache);

    useEffect(() => {
        if (features_cache) return;
        features_request = features_request || axiosWithAuth.get("/features")
            .then((res) => { features_cache = res.data; return res.data; })
            .catch(() => { features_request = null; return null; });
        let active = true;
        features_request.then((data) => { if (active && data) setFeatures(data); });
        return () => { active = false; };
    }, []);

    return features;
};
